import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { RoleForm } from "@/features/roles/role-form/role-form";
import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const EditRole = () => {
  const { roleId } = useParams();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchRole = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: { name, permissions },
          },
        } = await apiClient.get(`roles/${roleId}`);
        setDefaultValues({
          name,
          permissions,
        });
      } catch (error) {
        showSnackbar(
          getErrorMessage(error, "Gagal memperbarui peran")
        );
      } finally {
        setIsLoading(false);
      }
    };
    fetchRole();
  }, [roleId, showSnackbar]);

  const handleSubmit = async ({ name, permissions }) => {
    try {
      await apiClient.put(`roles/${roleId}`, {
        name,
        permissions,
      });
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal memperbarui peran")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Ubah Peran"
      breadcrumbs={[
        { title: "Peran", path: "/setting/roles" },
        { title: "Ubah" },
      ]}
    >
      <RoleForm
        isLoading={isLoading}
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Simpan
          </Button>
        )}
      />
    </PageContainer>
  );
};
